module.exports = __webpack_public_path__ + "static/img/zengo-m1-1@2x.f5b8302.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/zengo-m1-1@2x.jpg
// module id = 520
// module chunks = 0